"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavePosition = void 0;
const react_1 = require("react");
const throttle_debounce_1 = require("throttle-debounce");
const router_1 = require("@reach/router");
exports.SavePosition = () => {
    const location = router_1.useLocation();
    react_1.useEffect(() => {
        const savePosition = throttle_debounce_1.debounce(100, () => {
            sessionStorage.setItem("savedPosition", JSON.stringify({ pathname: location.pathname, position: window.scrollY }));
        });
        savePosition();
        window.addEventListener("scroll", savePosition);
        window.addEventListener("resize", savePosition);
        const mutationObserver = new MutationObserver(() => savePosition);
        mutationObserver.observe(document.body, { childList: true, subtree: true });
        return () => {
            window.removeEventListener("scroll", savePosition);
            window.removeEventListener("resize", savePosition);
            mutationObserver.disconnect();
        };
    }, [location]);
    return null;
};
//# sourceMappingURL=SavePosition.js.map